import AddIcon from '@mui/icons-material/Add';
import { Box } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid';

export const baseColumns: GridColDef[] = [
    { field: 'id', headerName: 'Product ID', minWidth: 200 },
    {
        field: 'imageUrl',
        headerName: 'Image',
        minWidth: 200,
        sortable: false,
        renderCell: (params) => {
            return <ProductImageCell imageUrl={params.row.imageUrl} id={params.row.id} />;
        },
    },
    { field: 'name', headerName: 'Product Name', minWidth: 250 },
    { field: 'term', headerName: 'Contract Term', minWidth: 150, sortable: false },
    { field: 'connectivity', headerName: 'Connectivity', minWidth: 200, sortable: false },
];

export const actionColumn: GridColDef = {
    field: 'action',
    headerName: '',
    minWidth: 300,
    sortable: false,
    renderCell: () => {
        return (
            <Box className="btn-medium-with-icon btn-dark">
                <Box className="flex" sx={{ padding: '2px 4px' }}>
                    <AddIcon sx={{ marginRight: '3px' }} />
                    <Box>
                        <Box sx={{ marginTop: '1px', fontSize: '16px' }}>Add</Box>
                    </Box>
                </Box>
            </Box>
        );
    },
};

export const GetProductColumnsWithAddButton = (): GridColDef[] => {
    return [...baseColumns, actionColumn];
};

export const GetProductColumnsWithoutAddButton = (): GridColDef[] => {
    return [...baseColumns];
};

export const ProductImageCell = ({ imageUrl, id }: { imageUrl: string; id: string | number }) => {
    return (
        <Box sx={{ padding: '10px' }}>
            <img src={imageUrl} width="70" alt={`product_${id}`} />
        </Box>
    );
};
